// removed by extract-text-webpack-plugin
module.exports = {"header":"XvxylIbs8nZqOZ4v28xPP","settings-view":"_2vwJJjR6kBOhizvLBlUOon"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/ShortcutHelper.styl
// module id = 489
// module chunks = 0